export const fixSubscriptionErrorsMutation = `
  mutation($subscriptionId: String!, $contactId: String!, $errorCode: String!, $errorDescription: String!) {
    fixSubscriptionErrors(subscriptionId: $subscriptionId, contactId: $contactId, errorCode: $errorCode, errorDescription: $errorDescription) {
      success {
        message
      }
      error {
        message
      }
      statusCode
    }
  }
`;

export interface ISuccess {
  message: string;
}

export interface IError {
  message: string;
}

export interface IFixSubscriptionErrorsResult {
  success: ISuccess;
  error: IError;
  statusCode: number;
}

export interface IFixSubscriptionErrorsResponse {
  fixSubscriptionErrors: IFixSubscriptionErrorsResult;
}